export function canRequestQuotationReworkForStatus(status?: string | null): boolean {
  const normalized = String(status || '').toUpperCase()
  return (
    normalized === 'SUBMITTED' ||
    normalized === 'PENDING_OWNER_APPROVAL' ||
    normalized === 'OWNER_APPROVED' ||
    normalized === 'SENT_TO_VESSEL' ||
    normalized === 'SENT_TO_VESSEL_FOR_SELECTION' ||
    normalized === 'SENT_FOR_REWORK' ||
    normalized === 'UPDATED_AFTER_REWORK'
  )
}
